import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { API_BASE_URL } from '../../config/api'; // ✅ Import eklendi
import './ArticleForm.css';

const PracticeAreaForm = ({ practiceArea, onClose, onSuccess }) => {
    const [activeTab, setActiveTab] = useState('TR');
    const [formData, setFormData] = useState({
        titleTR: '',
        descriptionTR: '',
        contentTR: '',
        titleEN: '',
        descriptionEN: '',
        contentEN: '',
        titleFR: '',
        descriptionFR: '',
        contentFR: '',
        image: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const token = localStorage.getItem('adminToken');

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['blockquote', 'code-block'],
            ['link'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'list', 'bullet',
        'blockquote', 'code-block',
        'link'
    ];

    useEffect(() => {
        if (practiceArea) {
            setFormData({
                titleTR: practiceArea.titleTR || '',
                descriptionTR: practiceArea.descriptionTR || '',
                contentTR: practiceArea.contentTR || '',
                titleEN: practiceArea.titleEN || '',
                descriptionEN: practiceArea.descriptionEN || '',
                contentEN: practiceArea.contentEN || '',
                titleFR: practiceArea.titleFR || '',
                descriptionFR: practiceArea.descriptionFR || '',
                contentFR: practiceArea.contentFR || '',

                image: practiceArea.image || ''
            });
        }
    }, [practiceArea]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setError('');
    };

    const handleContentChange = (value, lang) => {
        setFormData({
            ...formData,
            [`content${lang}`]: value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!formData.titleTR || !formData.descriptionTR || !formData.contentTR) {
            setError('Türkçe başlık, açıklama ve içerik zorunludur!');
            setLoading(false);
            return;
        }

        try {
            const payload = {
                titleTR: formData.titleTR.trim(),
                descriptionTR: formData.descriptionTR.trim(),
                contentTR: formData.contentTR.trim(),
                titleEN: formData.titleEN?.trim() || '',
                descriptionEN: formData.descriptionEN?.trim() || '',
                contentEN: formData.contentEN?.trim() || '',
                titleFR: formData.titleFR?.trim() || '',
                descriptionFR: formData.descriptionFR?.trim() || '',
                contentFR: formData.contentFR?.trim() || '',
                image: formData.image?.trim() || ''
            };

            const url = practiceArea
                ? `${API_BASE_URL}/api/practicearea/${practiceArea.id}` // ✅ Dinamik URL
                : `${API_BASE_URL}/api/practicearea`; // ✅ Dinamik URL

            const method = practiceArea ? 'PUT' : 'POST';

            console.log('📤 Sending payload:', payload);

            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            console.log('📥 Response status:', response.status);

            if (response.ok) {
                const data = await response.json();
                console.log('✅ Success:', data);
                alert(practiceArea ? 'Hizmet başarıyla güncellendi!' : 'Hizmet başarıyla oluşturuldu!');

                if (onSuccess) {
                    onSuccess(data);
                }
                if (onClose) {
                    onClose();
                }
            } else {
                const errorText = await response.text();
                console.error('❌ Backend error:', errorText);

                try {
                    const errorData = JSON.parse(errorText);
                    setError(errorData.error || errorData.title || 'Bir hata oluştu!');
                } catch {
                    setError(`Sunucu hatası: ${response.status}`);
                }
            }
        } catch (err) {
            console.error('💥 Submit error:', err);
            setError('Bağlantı hatası: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="article-form">
            <div className="form-header">
                <h3>
                    <i className="fa fa-briefcase"></i> {practiceArea ? 'Hizmet Düzenle' : 'Yeni Hizmet Ekle'}
                </h3>
                <button onClick={onClose} className="btn-close-form">
                    <i className="fa fa-times"></i>
                </button>
            </div>

            {error && (
                <div className="form-error" style={{ whiteSpace: 'pre-wrap' }}>
                    <i className="fa fa-exclamation-circle"></i> {error}
                </div>
            )}

            <div className="language-tabs">
                <button
                    type="button"
                    className={`tab-btn ${activeTab === 'TR' ? 'active' : ''}`}
                    onClick={() => setActiveTab('TR')}
                >
                    🇹🇷 Türkçe <span className="required-badge">Zorunlu</span>
                </button>
                <button
                    type="button"
                    className={`tab-btn ${activeTab === 'EN' ? 'active' : ''}`}
                    onClick={() => setActiveTab('EN')}
                >
                    🇬🇧 English <span className="optional-badge">Opsiyonel</span>
                </button>
                <button
                    type="button"
                    className={`tab-btn ${activeTab === 'FR' ? 'active' : ''}`}
                    onClick={() => setActiveTab('FR')}
                >
                    🇫🇷 Français <span className="optional-badge">Opsiyonel</span>
                </button>
            </div>

            <form onSubmit={handleSubmit} className="article-form-content">

                {/* Türkçe İçerik */}
                {activeTab === 'TR' && (
                    <div className="tab-content">
                        <div className="form-group">
                            <label htmlFor="titleTR">
                                Başlık (Türkçe) <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="titleTR"
                                name="titleTR"
                                value={formData.titleTR}
                                onChange={handleChange}
                                placeholder="Hizmet başlığını girin (örn: Ceza Hukuku)"
                                required
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="descriptionTR">
                                Kısa Açıklama (Türkçe) <span className="required">*</span>
                            </label>
                            <textarea
                                id="descriptionTR"
                                name="descriptionTR"
                                value={formData.descriptionTR}
                                onChange={handleChange}
                                placeholder="Hizmet özeti (liste sayfasında görünecek)"
                                rows="3"
                                required
                                disabled={loading}
                            />
                            <span className="form-help">Liste sayfasında gösterilecek kısa açıklama</span>
                        </div>

                        <div className="form-group">
                            <label htmlFor="contentTR">
                                Detaylı İçerik (Türkçe) <span className="required">*</span>
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.contentTR}
                                onChange={(value) => handleContentChange(value, 'TR')}
                                modules={modules}
                                formats={formats}
                                placeholder="Hizmetin detaylı açıklamasını buraya yazın..."
                                readOnly={loading}
                            />
                            <span className="form-help">Detay sayfasında gösterilecek tam içerik</span>
                        </div>
                    </div>
                )}

                {/* İngilizce İçerik */}
                {activeTab === 'EN' && (
                    <div className="tab-content">
                        <div className="form-group">
                            <label htmlFor="titleEN">Title (English)</label>
                            <input
                                type="text"
                                id="titleEN"
                                name="titleEN"
                                value={formData.titleEN}
                                onChange={handleChange}
                                placeholder="Service title in English (e.g., Criminal Law)"
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="descriptionEN">Short Description (English)</label>
                            <textarea
                                id="descriptionEN"
                                name="descriptionEN"
                                value={formData.descriptionEN}
                                onChange={handleChange}
                                placeholder="Service summary (shown on list page)"
                                rows="3"
                                disabled={loading}
                            />
                            <span className="form-help">Brief description shown on the list page</span>
                        </div>

                        <div className="form-group">
                            <label htmlFor="contentEN">Detailed Content (English)</label>
                            <ReactQuill
                                theme="snow"
                                value={formData.contentEN}
                                onChange={(value) => handleContentChange(value, 'EN')}
                                modules={modules}
                                formats={formats}
                                placeholder="Write detailed service description here..."
                                readOnly={loading}
                            />
                            <span className="form-help">Full content shown on the detail page</span>
                        </div>
                    </div>
                )}

                {/* Fransızca İçerik */}
                {activeTab === 'FR' && (
                    <div className="tab-content">
                        <div className="form-group">
                            <label htmlFor="titleFR">Titre (Français)</label>
                            <input
                                type="text"
                                id="titleFR"
                                name="titleFR"
                                value={formData.titleFR}
                                onChange={handleChange}
                                placeholder="Titre du service (ex: Droit Pénal)"
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="descriptionFR">Brève Description (Français)</label>
                            <textarea
                                id="descriptionFR"
                                name="descriptionFR"
                                value={formData.descriptionFR}
                                onChange={handleChange}
                                placeholder="Résumé du service (affiché sur la page de liste)"
                                rows="3"
                                disabled={loading}
                            />
                            <span className="form-help">Brève description affichée sur la page de liste</span>
                        </div>

                        <div className="form-group">
                            <label htmlFor="contentFR">Contenu Détaillé (Français)</label>
                            <ReactQuill
                                theme="snow"
                                value={formData.contentFR}
                                onChange={(value) => handleContentChange(value, 'FR')}
                                modules={modules}
                                formats={formats}
                                placeholder="Écrivez la description détaillée du service ici..."
                                readOnly={loading}
                            />
                            <span className="form-help">Contenu complet affiché sur la page de détail</span>
                        </div>
                    </div>
                )}

                {/* Ortak Alanlar */}
                <div className="common-fields">
                    <h4>Ortak Bilgiler (Tüm Diller İçin)</h4>



                    <div className="form-group">
                        <label htmlFor="image">
                            <i className="fa fa-image"></i> Görsel URL (Opsiyonel)
                        </label>
                        <input
                            type="url"
                            id="image"
                            name="image"
                            value={formData.image}
                            onChange={handleChange}
                            placeholder="https://example.com/service-image.jpg"
                            disabled={loading}
                        />
                        <span className="form-help">Detay sayfasında gösterilecek görsel URL'i</span>
                    </div>
                </div>

                {/* Form Actions */}
                <div className="form-actions">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn-form-cancel"
                        disabled={loading}
                    >
                        <i className="fa fa-times"></i> İptal
                    </button>
                    <button
                        type="submit"
                        className="btn-form-submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <i className="fa fa-spinner fa-spin"></i> Kaydediliyor...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-save"></i> {practiceArea ? 'Güncelle' : 'Oluştur'}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PracticeAreaForm;